<hc-tile tight="true" class="cdp-app-card-tile">
    <div
        class="cdp-fav-ico icon-star{{ application?.isFavorite ? ' favorited' : '-o' }}"
        hcTooltip="{{ application?.isFavorite ? 'Remove from' : 'Add to' }} favorites"
        (click)="favClicked($event)"
    ></div>
    <div class="card-main-container">
        <div hcTileHeader [type]="'center'">
            <div class="card-logo-container">
                <cdp-app-icon [app]="application"></cdp-app-icon>
            </div>
            <div class="card-title">
                <span [innerHTML]="application?.name | searchHighlight: searchText"></span>
            </div>
            <div class="card-by" *ngIf="application?.providedBy">
                By <span [innerHTML]="application?.providedBy | searchHighlight: searchText"></span>
            </div>
        </div>
        <div class="card-description">
            <span
                [title]="application?.description"
                [innerHTML]="application?.description | searchHighlight: searchText"
            ></span>
        </div>
    </div>
    <div [hcTooltip]="application?.action | appActionButtonTitle: application?.name">
        <a
            class="card-button-width"
            hc-button
            [disabled]="!application?.url"
            [buttonStyle]="application?.action | appActionButtonStyle"
            target="_blank"
            [attr.data-app-name]="application?.name"
            [attr.data-app-id]="application?.id"
            [attr.data-parentid]="application?.name"
            (click)="launch($event)"
            >{{ application?.action }}</a
        >
    </div>
    <div class="card-footer" [class.card-footer-has-links]="hasLinks">
        <a
            *ngIf="application?.docs"
            class="card-footer-button"
            hc-button
            size="sm"
            title="Docs"
            buttonStyle="minimal"
            target="_blank"
            [href]="application?.docs"
            >Docs</a
        >
        <a
            *ngIf="application?.community"
            class="card-footer-button"
            hc-button
            size="sm"
            title="Community"
            buttonStyle="minimal"
            target="_blank"
            [href]="application?.community"
            >Community</a
        >
    </div>
</hc-tile>
